import * as moment from 'moment';
import 'moment-business-time';
import { ICallBackHoursModel } from 'features/CallBack/types';
import { ICallBackTimeSlots } from 'features/CallBack/types';
import { isDateTimeSkeleton } from '@formatjs/icu-messageformat-parser';

export const IsCallCenterWorkingTime = (
  callCenterWorkingDaysHours: any,
  callCenterHolidays: any,
) => {
  moment.updateLocale('en', {
    workinghours: callCenterWorkingDaysHours,
    holidays: callCenterHolidays,
  });
  let CurrentDate = new Date(new Date().toLocaleString('en-US', { timeZone: 'Europe/Berlin' }));
  return moment.default(CurrentDate, 'DD-MMM-YYYY HH:mm').isWorkingTime();
};
function padTo2Digits(num: number) {
  return String(num).padStart(2, '0');
}
export const GetCallCenterCallBackHours = (
  callCenterWorkingDaysHours: any,
  callCenterHolidays: any,
  CallBackTimeSlot: number,
): ICallBackHoursModel => {
  moment.updateLocale('en', {
    workinghours: callCenterWorkingDaysHours,
    holidays: callCenterHolidays,
  });

  const CallbackHours: ICallBackHoursModel = {
    CurrentDayTimeSlots: [],
    NextDayTimeSlots: [],
    CurrentDayTitle: '',
    NextDayTitle: '',
    CurrentDateFormatted: '',
    NextDateFormatted: '',
  };

  let CurrentDate = new Date(new Date().toLocaleString('en-US', { timeZone: 'Europe/Berlin' }));
  let noOfDaysForSlots = 2;
  let currentNoOfDayForSlots = 0;
  while (currentNoOfDayForSlots < noOfDaysForSlots) {
    if (moment.default(CurrentDate).isWorkingDay()) {
      let CurrentDateStart = moment
        .default(CurrentDate)
        .format('YYYY-MM-DD 00:00');
      let CurrentDateEnd = moment
        .default(CurrentDate)
        .format('YYYY-MM-DD 23:59');

      let CurrentWorkingStartTime = moment
        .default(CurrentDateStart)
        .nextWorkingTime()
        .toDate();
      let currentWorkingEndTime = moment
        .default(CurrentDateEnd)
        .lastWorkingTime()
        .toDate();
      let split = SplitTimeSlot(
        CurrentWorkingStartTime,
        currentWorkingEndTime,
        CallBackTimeSlot,
        CurrentDate,
        callCenterWorkingDaysHours,
        callCenterHolidays,
      );
      if (split.length >= 1) {
        if (currentNoOfDayForSlots === 0) {
          CallbackHours.CurrentDayTitle = moment
            .default(CurrentDate)
            .format('ddd');
          CallbackHours.CurrentDayTimeSlots = split;
          CallbackHours.CurrentDateFormatted = moment
            .default(CurrentDate)
            .format('D MMM');
        }
        if (currentNoOfDayForSlots === 1) {
          CallbackHours.NextDayTitle = moment
            .default(CurrentDate)
            .format('ddd');
          CallbackHours.NextDayTimeSlots = split;
          CallbackHours.NextDateFormatted = moment
            .default(CurrentDate)
            .format('D MMM');
        }
        let datepassed = moment.default(CurrentDate).days();
        let dateCurrent = moment.default().days();
        if (datepassed == dateCurrent && currentNoOfDayForSlots == 0) {
          CallbackHours.CurrentDayTitle = 'Today';
        } else if (
          datepassed == dateCurrent + 1 &&
          currentNoOfDayForSlots == 0
        ) {
          CallbackHours.CurrentDayTitle = 'Tomorrow';
        } else if (
          datepassed == dateCurrent + 1 &&
          currentNoOfDayForSlots == 1
        ) {
          CallbackHours.NextDayTitle = 'Tomorrow';
        }
        currentNoOfDayForSlots = currentNoOfDayForSlots + 1;
      }
    }
    CurrentDate = moment
      .default(
        moment.default(CurrentDate).nextWorkingDay().format('YYYY-MM-DD'),
      )
      .toDate();
  }
  return CallbackHours;
};

export const SplitTimeSlot = (
  startDateTime: any,
  EndDateTime: any,
  durationInMinutes: any,
  currentDateTime: any,
  callCenterWorkingDaysHours: any,
  callCenterHolidays: any,
): ICallBackTimeSlots[] => {
  moment.updateLocale('en', {
    workinghours: callCenterWorkingDaysHours,
    holidays: callCenterHolidays,
  });

  let startDateTimeCurrent = startDateTime;
  let EndDateTimeCurrent = EndDateTime;
  const callBackTimeSlots: ICallBackTimeSlots[] = [];
  let currentDateTimeMoment = moment.default(currentDateTime);
  let endDateTimeMoment = moment.default(EndDateTimeCurrent);

  if (
    endDateTimeMoment.workingDiff(currentDateTimeMoment, 'minutes') >
    durationInMinutes
  ) {
    while (startDateTimeCurrent < EndDateTimeCurrent) {
      let tempStartDateTime = startDateTimeCurrent;
      let tempEndDateTime = EndDateTimeCurrent;
      let addedTime = moment
        .default(tempStartDateTime)
        .addWorkingTime(durationInMinutes, 'minutes');
      tempStartDateTime = addedTime.toDate();
      if (tempStartDateTime <= EndDateTimeCurrent) {
        let dateToAdd = moment
          .default(currentDateTimeMoment)
          .addWorkingTime(durationInMinutes, 'minutes')
          .toDate();
        if (tempStartDateTime < dateToAdd) {
          startDateTimeCurrent = tempStartDateTime;
          continue;
        } else {
          const callBackTimeSlot: ICallBackTimeSlots = {
            TimeSlotWithDate:
              moment
                .default(startDateTimeCurrent)
                .format('YYYY-MM-DD  HH:mm:ss') +
              '|' +
              moment
                .default(tempStartDateTime)
                .format('YYYY-MM-DD  HH:mm:ss'),
            TimeSlot:
              padTo2Digits(startDateTimeCurrent.getHours()) +
              ':' +
              padTo2Digits(startDateTimeCurrent.getMinutes()) +
              '-' +
              padTo2Digits(tempStartDateTime.getHours()) +
              ':' +
              padTo2Digits(tempStartDateTime.getMinutes()),
          };

          callBackTimeSlots.push(callBackTimeSlot);
          startDateTimeCurrent = tempStartDateTime;
        }
      } else {
        startDateTimeCurrent = tempStartDateTime;
      }
    }
  }
  return callBackTimeSlots;
};
